import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

export interface TextboxEditorAction {
  icon?: string;
  iconColor?: string;
  action: () => void;
  isActive?: () => boolean;
}

@Component({
  selector: "app-textbox-editor",
  templateUrl: "./textbox-editor.component.html",
  styleUrls: ["./textbox-editor.component.scss"],
})
export class TextboxEditorComponent implements OnInit {
  textValue: string;
  @Input() textInput: string;
  @Input() actions: TextboxEditorAction[] = [];
  @Output() textOutput: EventEmitter<string> = new EventEmitter<string>();
  constructor(readonly activeModal: NgbActiveModal) {}
  ngOnInit(): void {
    this.textValue = this.textInput;
  }
  close() {
    this.activeModal.close();
  }
  save() {
    this.textOutput.emit(this.textValue);
    this.activeModal.close();
  }
}
